.cx{justify-content:flex-end;}